import React from 'react';
import * as S from './TableTitle.styles';

interface TableTitleProps {
  title: string;
  children?: React.ReactNode;
}

export const TableTitle: React.FC<TableTitleProps> = ({ title, children }) => {
  return (
    <S.TableWrapper>
      <S.Title>{title}</S.Title>
      {children}
    </S.TableWrapper>
  );
};
